export interface HolidaysState
{
    models: Record<string, any>;
    holidays: string[];
}

export const HOLIDAYS_FEATURE_KEY = 'holidays';